webpackJsonp([213534597649335],{

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stylesModule = __webpack_require__(106);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var xDown = null;
	var yDown = null;
	
	var Poem = function (_Component) {
	  _inherits(Poem, _Component);
	
	  function Poem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Poem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      verticalAlignment: 'center'
	    }, _this.handleTouchStart = function (evt) {
	      var firstTouch = evt.touches[0];
	      xDown = firstTouch.clientX;
	      yDown = firstTouch.clientY;
	    }, _this.handleTouchMove = function (evt) {
	      var _this$props = _this.props,
	          goToNext = _this$props.goToNext,
	          goToPrev = _this$props.goToPrev;
	
	      if (!xDown || !yDown) {
	        return;
	      }
	
	      var xUp = evt.touches[0].clientX;
	      var yUp = evt.touches[0].clientY;
	
	      var xDiff = xDown - xUp;
	      var yDiff = yDown - yUp;
	
	      if (Math.abs(xDiff) > Math.abs(yDiff)) {
	        if (xDiff > 0) {
	          goToNext();
	        } else {
	          goToPrev();
	        }
	      }
	      xDown = null;
	      yDown = null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Poem.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    if (this.contentEl) {
	      this.startTimeout = setTimeout(function () {
	        if (_this2.contentEl.offsetHeight > window.innerHeight - 80) {
	          _this2.setState({
	            verticalAlignment: 'start'
	          });
	        }
	      }, 50);
	    }
	    document.addEventListener('touchstart', this.handleTouchStart, false);
	    document.addEventListener('touchmove', this.handleTouchMove, false);
	  };
	
	  Poem.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('touchstart', this.handleTouchStart, false);
	    document.removeEventListener('touchmove', this.handleTouchMove, false);
	  };
	
	  Poem.prototype.render = function render() {
	    var _this3 = this;
	
	    var stanzas = this.props.stanzas;
	    var verticalAlignment = this.state.verticalAlignment;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.wrapper, style: { alignItems: verticalAlignment } },
	      _react2.default.createElement(
	        'div',
	        {
	          className: _stylesModule2.default.content,
	          ref: function ref(el) {
	            _this3.contentEl = el;
	          }
	        },
	        stanzas && stanzas.map(function (_ref, i) {
	          var alignment = _ref.alignment,
	              text = _ref.text;
	          return _react2.default.createElement('div', {
	            dangerouslySetInnerHTML: {
	              __html: text.childMarkdownRemark.html
	            },
	            style: { textAlign: alignment || 'left' },
	            key: 'parent' + i
	          });
	        })
	      )
	    );
	  };
	
	  return Poem;
	}(_react.Component);
	
	Poem.propTypes = {
	  goToNext: _propTypes2.default.func.isRequired,
	  goToPrev: _propTypes2.default.func.isRequired,
	  stanzas: _propTypes2.default.array.isRequired
	};
	
	exports.default = Poem;
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-Poem----styles-module---wrapper---3P2wb","content":"src-components-Poem----styles-module---content---2DPQu"};

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stylesModule = __webpack_require__(107);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Product = function Product(_ref) {
	  var images = _ref.images,
	      stanzas = _ref.stanzas;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.wrapper },
	    images && images.map(function (image, i) {
	      return _react2.default.createElement('img', {
	        className: _stylesModule2.default.image,
	        alt: image.title,
	        key: 'image' + i,
	        src: image.asset.file.url
	      });
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.content },
	      stanzas && stanzas.map(function (_ref2, i) {
	        var alignment = _ref2.alignment,
	            text = _ref2.text;
	        return _react2.default.createElement('div', {
	          dangerouslySetInnerHTML: { __html: text.childMarkdownRemark.html },
	          style: { textAlign: alignment || 'left' },
	          key: 'parent' + i
	        });
	      })
	    )
	  );
	};
	
	Product.propTypes = {
	  images: _propTypes2.default.array,
	  stanzas: _propTypes2.default.array
	};
	
	Product.defaultProps = {
	  images: [],
	  stanzas: []
	};
	
	exports.default = Product;
	module.exports = exports['default'];

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-Product----styles-module---wrapper---1pp9e","image":"src-components-Product----styles-module---image---1P36N","content":"src-components-Product----styles-module---content---2HtJx"};

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(57);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Poem = __webpack_require__(77);
	
	var _Poem2 = _interopRequireDefault(_Poem);
	
	var _Product = __webpack_require__(78);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _ProjectImage = __webpack_require__(42);
	
	var _ProjectImage2 = _interopRequireDefault(_ProjectImage);
	
	var _getProjects = __webpack_require__(27);
	
	var _getProjects2 = _interopRequireDefault(_getProjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_Component) {
	  _inherits(Project, _Component);
	
	  function Project() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Project);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      index: null,
	      nextSlug: null,
	      prevSlug: null
	    }, _this.onKeyPress = function (e) {
	      var key = e.keyCode ? e.keyCode : e.which;
	      if (key === 39) _this.goToNext();
	      if (key === 37) _this.goToPrev();
	    }, _this.goToNext = function (state) {
	      var nextSlug = _this.state.nextSlug;
	
	      (0, _gatsbyLink.navigateTo)({
	        pathname: '/' + nextSlug,
	        state: state
	      });
	    }, _this.goToPrev = function () {
	      var prevSlug = _this.state.prevSlug;
	
	      (0, _gatsbyLink.navigateTo)({
	        pathname: '/' + prevSlug
	      });
	    }, _this.handleClick = function () {
	      _this.goToNext();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Project.prototype.componentWillMount = function componentWillMount() {
	    var data = this.props.data;
	
	    var projects = (0, _getProjects2.default)(data.allContentfulProject.edges);
	    var lastProject = projects.length - 1;
	
	    var thisSlug = data.contentfulProject.slug;
	    var thisIndex = projects.findIndex(function (_ref) {
	      var slug = _ref.slug;
	      return thisSlug === slug;
	    });
	
	    this.setState({
	      index: thisIndex + 1,
	      nextSlug: thisIndex !== lastProject ? projects[thisIndex + 1].slug : projects[0].slug,
	      prevSlug: thisIndex !== 0 ? projects[thisIndex - 1].slug : projects[lastProject].slug
	    });
	  };
	
	  Project.prototype.componentDidMount = function componentDidMount() {
	    var data = this.props.data;
	    var _data$contentfulProje = data.contentfulProject,
	        buyLink = _data$contentfulProje.buyLink,
	        poem = _data$contentfulProje.poem;
	
	    window.addEventListener('keyup', this.onKeyPress);
	    if (!buyLink && poem) {
	      document.body.style.overflow = 'hidden';
	    }
	  };
	
	  Project.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('keyup', this.onKeyPress);
	    document.body.style.overflow = 'auto';
	  };
	
	  Project.prototype.render = function render() {
	    var data = this.props.data;
	    var index = this.state.index;
	    var _data$contentfulProje2 = data.contentfulProject,
	        buyLink = _data$contentfulProje2.buyLink,
	        client = _data$contentfulProje2.client,
	        images = _data$contentfulProje2.images,
	        slug = _data$contentfulProje2.slug,
	        title = _data$contentfulProje2.title,
	        poem = _data$contentfulProje2.poem;
	
	
	    var hasImages = images && images.length > 0;
	    var isProduct = !!buyLink;
	    var isPoem = !isProduct && poem && poem.length;
	    var isImage = !isProduct && !isPoem && hasImages;
	    var imagesSlug = hasImages ? '/' + slug + '/images/' : null;
	
	    // const scrolling = history.location.state && history.location.state.scrolling;
	
	    return _react2.default.createElement(
	      'div',
	      { key: slug },
	      _react2.default.createElement(_Header2.default, {
	        anchor: slug,
	        background: true,
	        buy: buyLink,
	        client: client,
	        id: index,
	        slug: imagesSlug,
	        title: title,
	        total: data.allContentfulProject.edges.length
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          onClick: this.handleClick,
	          style: {
	            cursor: 'e-resize',
	            height: '100vh',
	            width: '100vw'
	          }
	        },
	        isProduct && _react2.default.createElement(_Product2.default, {
	          images: images,
	          stanzas: poem
	        }),
	        isPoem && _react2.default.createElement(_Poem2.default, {
	          goToNext: this.goToNext,
	          goToPrev: this.goToPrev,
	          stanzas: poem
	        }),
	        isImage && _react2.default.createElement(_ProjectImage2.default, { src: images[0].asset.file.url })
	      )
	    );
	  };
	
	  return Project;
	}(_react.Component);
	
	exports.default = Project;
	
	
	Project.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stylesModule = __webpack_require__(49);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectImage = function ProjectImage(_ref) {
	  var src = _ref.src;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.box },
	      _react2.default.createElement('img', { className: _stylesModule2.default.fit, alt: 'Peter Miles Studio', src: src })
	    )
	  );
	};
	
	ProjectImage.propTypes = {
	  src: _propTypes2.default.string.isRequired
	};
	
	exports.default = ProjectImage;
	module.exports = exports['default'];

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-ProjectImage----styles-module---wrapper---1uB88","box":"src-components-ProjectImage----styles-module---box---2n14X","fit":"src-components-ProjectImage----styles-module---fit---rutPY"};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Project = __webpack_require__(79);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _getProjects = __webpack_require__(27);
	
	var _getProjects2 = _interopRequireDefault(_getProjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      project: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IndexPage.prototype.componentWillMount = function componentWillMount() {
	    var data = this.props.data;
	
	
	    var projects = (0, _getProjects2.default)(data.allContentfulProject.edges);
	    var randomProject = projects[Math.floor(Math.random() * projects.length)];
	
	    this.setState({ project: randomProject });
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        history = _props.history;
	    var project = this.state.project;
	
	
	    var projectData = {
	      allContentfulProject: data.allContentfulProject,
	      contentfulProject: project
	    };
	
	    return _react2.default.createElement(_Project2.default, { data: projectData, history: history });
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var INACTIVE = 'INACTIVE';
	
	function getProjects(edges) {
	  return edges.map(function (_ref) {
	    var node = _ref.node;
	    return node;
	  }).filter(function (node) {
	    return node.status !== INACTIVE;
	  });
	}
	
	exports.default = getProjects;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-996af195b77f38641e62.js